import React from 'react';
import { Box, Button, Checkbox, FormControl, FormGroup, FormControlLabel, FormLabel } from '@mui/material';
import Tip from './Tip';
import HTMLContent from './HTMLContent';
import AnswerResult from './AnswerResult';
import useQuestionAnswer from '../../hooks/useQuestionAnswer';

export default function ValidatedMultipleChoice(props) {
  const { answer, result, change, check } = useQuestionAnswer(props.questionKey, []);
  const promptId = `${props.questionKey}-directions`;
  const resultId = `${props.questionKey}-result`;
  const valid = props.choices.filter(c => c.validChecked).map(c => c.label);
  return <Box sx={{ width: '100%', minWidth: 0 }}>
    <FormControl component="fieldset" error={result === false || result === 'empty'} aria-describedby={resultId}>
      <FormLabel component="legend" id={promptId}>{props.directions || 'Select all correct statements.'}</FormLabel>
      <FormGroup>{props.choices.map(choice => <Box key={choice.label} sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel control={<Checkbox checked={answer.includes(choice.label)} onChange={event => change(event.target.checked ? [...answer, choice.label] : answer.filter(x => x !== choice.label))} />} label={<HTMLContent content={choice.label} />} />
        <Tip tip={choice.tip} describedBy={promptId} />
      </Box>)}</FormGroup>
    </FormControl>
    <Box sx={{ my: 1 }}><Button type="button" variant="outlined" aria-describedby={promptId}
      onClick={() => check(answer.length === 0 ? null : answer.length === valid.length && valid.every(x => answer.includes(x)))}>Check</Button></Box>
    <AnswerResult id={resultId} result={result} />
  </Box>;
}
